import heroIcon1 from "../../assets/images/heroIcon1.png";
import heroIcon2 from "../../assets/images/heroIcon2.png";

const HeroBanner = () => {
  return (
    <div className="w-full -mt-6 z-10 relative">
      {/* Top white section */}
      <div className="bg-white py-6 px-4 text-center rounded-t-3xl">
        <h2 className="text-xl font-semibold text-[#393938] mb-1">
          Your Recovery, Our Priority
        </h2>
        <p className="text-sm font-medium" style={{ color: "var(--partner-primary)" }}>
          Physica Brings Expert Physiotherapists to your doorstep
        </p>
      </div>

      {/* Bottom transparent section that overlaps background */}
      <div className="py-4 px-4 text-center bg-transparent">
        <div className="flex justify-center gap-4">
          <div className="flex items-center bg-[#fcfdff] rounded-xl px-3 py-2">
            <img src={heroIcon1} alt="Icon 1" className="w-9 h-9 mr-2" />
            <p className="text-left text-[#0F172A] text-xs font-semibold leading-tight">
              3000+ Patients <br />
              Recovered
            </p>
          </div>

          <div className="flex items-center bg-[#fcfdff] rounded-xl px-3 py-2">
            <img src={heroIcon2} alt="Icon 2" className="w-9 h-9 mr-2" />
            <p className="text-left text-[#0F172A] text-xs font-semibold leading-tight">
              100+ Trained, <br />
              Rated Doctors
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
